module.exports = __webpack_public_path__ + "img/bg.c3ac2a33.jpg";